import type { IntegrationSource } from "@/lib/checkout/integration-sources";
import { isSessionIntegrationSource } from "@/lib/checkout/integration-sources";

/** Analytics value for the ALL hotel booking funnel journey. */
export const GTM_HOTEL_FUNNEL_INTEGRATION_SOURCE = "HotelFunnel" as const;

export type GtmIntegrationSource =
  | typeof GTM_HOTEL_FUNNEL_INTEGRATION_SOURCE
  | "none";

export function toGtmIntegrationSource(
  source: IntegrationSource | null | undefined,
): GtmIntegrationSource {
  if (source && isSessionIntegrationSource(source)) {
    return GTM_HOTEL_FUNNEL_INTEGRATION_SOURCE;
  }

  return "none";
}

export function getGtmIntegrationSourceProps(
  source: IntegrationSource | null | undefined,
): Partial<{
  integration_source: typeof GTM_HOTEL_FUNNEL_INTEGRATION_SOURCE;
}> {
  const gtmSource = toGtmIntegrationSource(source);

  if (gtmSource === "none") {
    return {};
  }

  return { integration_source: GTM_HOTEL_FUNNEL_INTEGRATION_SOURCE };
}
